import { graphql } from "@/graphql/generated/gql";

export const getSectorQueryDocument = graphql(/* GraphQL */ `
  query GetSector($input: GetSectorInput!) {
    sector(getSectorInput: $input) {
      ...SectorFields
      sectorSliceList {
        ...SectorSliceFields
      }
      subsectorList {
        ...SubsectorFields
        subsubsectorList {
          ...SubsubsectorFields
        }
      }
      energySourceInstanceList {
        ...EnergySourceInstanceFields
        energySource {
          ...EnergySourceFields
        }
      }
    }
  }
`);

export const getSubsectorQueryDocument = graphql(/* GraphQL */ `
  query GetSubsector($input: GetSubsectorInput!) {
    subsector(getSubsectorInput: $input) {
      ...SubsectorFields
      subsubsectorList {
        ...SubsubsectorFields
      }
    }
  }
`);

export const getSubsectorListQueryDocument = graphql(/* GraphQL */ `
  query GetSubsectorList {
    subsectorList {
      ...SubsectorFields
    }
  }
`);

export const getSectorListQueryDocument = graphql(/* GraphQL */ `
  query GetSectorList {
    sectorList {
      ...SectorFields
      subsectorList {
        ...SubsectorFields
        subsubsectorList {
          ...SubsubsectorFields
        }
      }
      energySourceInstanceList {
        ...EnergySourceInstanceFields
        energySource {
          ...EnergySourceFields
        }
      }
    }
  }
`);
